__turbopack_context__.v({
  "actions": "ProductStrip-module-scss-module__ZTIibW__actions",
  "buttonGroup": "ProductStrip-module-scss-module__ZTIibW__buttonGroup",
  "ctaMobile": "ProductStrip-module-scss-module__ZTIibW__ctaMobile",
  "header": "ProductStrip-module-scss-module__ZTIibW__header",
  "heading": "ProductStrip-module-scss-module__ZTIibW__heading",
  "inSliceZone": "ProductStrip-module-scss-module__ZTIibW__inSliceZone",
  "mini": "ProductStrip-module-scss-module__ZTIibW__mini",
  "root": "ProductStrip-module-scss-module__ZTIibW__root",
  "slide": "ProductStrip-module-scss-module__ZTIibW__slide",
  "swiper": "ProductStrip-module-scss-module__ZTIibW__swiper",
});
